import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";

import { CityProvider } from "./context/CityContext";

import Home from "./pages/Home";
import ActivePage from "./pages/ActivePage";
import CrazyDealsPage from "./pages/CrazyDealsPage";
import CruiseDetailPage from "./pages/CruiseDetailPage";
import CruiseListPage from "./pages/CruiseListPage";
import CruiseSearchPage from "./pages/CruiseSearchPage";
import DealPageFlightHotelPage from "./pages/DealPageFlightHotelPage";
import HolidayPage from "./pages/HolidayPage";
import HolidayListPage from "./pages/HolidayListPage";
import HotelDetailPage from "./pages/HotelDetailPage";
import ListHotelPage from "./pages/ListHotelPage";
import SubCategoryPage from "./pages/SubCategoryPage";
import SubSubCategoryPage from "./pages/SubSubCategoryPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import VisaDetailPage from "./pages/VisaDetailPage";
import VisaSearchPage from "./pages/VisaSearchPage";
import ScrollToTop from "./components/ScrollToTop";
import BookingPage from "./components/BookingPage";
import ViewAllPage from "./components/ViewAllPage";
import LandingPage from "./components/LandingPage";

function App() {
  return (
    <CityProvider>
      <Router>
        <ScrollToTop />

        <Routes>
          {/* =========================================
              LANDING PAGE
          ========================================= */}
          <Route path="/" element={<LandingPage />} />

          {/* =========================================
              MAIN WEBSITE LAYOUT
          ========================================= */}
          <Route element={<MainLayout />}>

            {/* =========================================
                CITY
            ========================================= */}
            <Route
              path="/city/:slug"
              element={<Home />}
            />

            {/* =========================================
                ACTIVITY
            ========================================= */}

            {/* /activity */}
            <Route
              path="/activity"
              element={<ActivePage />}
            />

            {/* /activity/:subSlug */}
            <Route
              path="/activity/:subSlug"
              element={<SubCategoryPage />}
            />

            {/* /activity/:productSlug/:subProductSlug */}
            <Route
              path="/activity/:productSlug/:subProductSlug"
              element={<SubSubCategoryPage />}
            />

            {/* =========================================
                OTHER STATIC PAGES
            ========================================= */}

            {/* /booking */}
            <Route
              path="/booking"
              element={<BookingPage />}
            />

            {/* /view-all/:type */}
            <Route
              path="/view-all/:type"
              element={<ViewAllPage />}
            />

            {/* /crazy-deals */}
            <Route
              path="/crazy-deals"
              element={<CrazyDealsPage />}
            />

            {/* /cruise-detail */}
            <Route
              path="/cruise-detail"
              element={<CruiseDetailPage />}
            />

            {/* /cruise-list */}
            <Route
              path="/cruise-list"
              element={<CruiseListPage />}
            />

            {/* /cruise-search */}
            <Route
              path="/cruise-search"
              element={<CruiseSearchPage />}
            />

            {/* /deal-flight-hotel */}
            <Route
              path="/deal-flight-hotel"
              element={<DealPageFlightHotelPage />}
            />

            {/* /holidays */}
            <Route
              path="/holidays"
              element={<HolidayPage />}
            />

            {/* /holiday-list */}
            <Route
              path="/holiday-list"
              element={<HolidayListPage />}
            />

            {/* /hotel */}
            <Route
              path="/hotel"
              element={<HotelDetailPage />}
            />

            {/* /hotel-detail */}
            <Route
              path="/hotel-detail"
              element={<ListHotelPage />}
            />

            {/* /visa-detail */}
            <Route
              path="/visa-detail"
              element={<VisaDetailPage />}
            />

            {/* /visa-search */}
            <Route
              path="/visa-search"
              element={<VisaSearchPage />}
            />

            {/* =========================================
                PRODUCT DETAILS
            ========================================= */}

            {/* 
              Example:
              /desert-safari-in-dubai/evening-desert-safari-dinner-dubai
              
              category = desert-safari-in-dubai
              detailSlug = evening-desert-safari-dinner-dubai
            */}
            <Route
              path="/:category/:detailSlug"
              element={<ProductDetailsPage />}
            />

            {/* =========================================
                SINGLE CATEGORY
            ========================================= */}

            {/* 
              Example:
              /desert-safari-in-dubai

              category = desert-safari-in-dubai
            */}
            <Route
              path="/:category"
              element={<SubCategoryPage />}
            />

          </Route>
        </Routes>
      </Router>
    </CityProvider>
  );
}

export default App;
